import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import i18n from "i18next";
import k from "src/i18n/keys";

import Header from "src/components/SearchHeader.old";
import Table from "./Table";
import Navigation from "src/components/Manage/Navigation";
import { searchForm } from "src/actions/forms";
import FormBuilder from "src/components/Manage/Forms/Builder";
import { TemplatesContainer } from "./styles";

interface Props {
  formModal: boolean;
  openFormModal: () => void;
}

const TemplatesNew = ({
  formModal,
  openFormModal,
}: Props): React.ReactElement => {
  const dispatch = useDispatch();
  const [text, setText] = useState("");

  useEffect(() => {
    dispatch(searchForm(""));
  }, [dispatch]);

  const handleChange = (newValue: string) => {
    setText(newValue);
  };

  return (
    <TemplatesContainer>
      {formModal && <FormBuilder />}
      <Navigation tab="forms" />
      <Header
        text={text}
        handleChange={handleChange}
        handleCreate={() => openFormModal()}
        button={i18n.t(k.NEW_FORM_TEMPLATE)}
        instant
      />

      <Table searchText={text} />
    </TemplatesContainer>
  );
};

export default TemplatesNew;
